exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh5[data-v-0447f8b6]{color:#000;margin:18px 0;cursor:pointer\n}\n.content[data-v-0447f8b6]{margin-bottom:12px;padding-top:12px;padding-bottom:12px;font-size:.95em;line-height:18px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0447f8b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FaqEntry.vue
// module id = it8c
// module chunks = 1